module.exports = __webpack_public_path__ + "static/img/BrechtGeorge_Kulchur3_1961_p19.703c65b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/BrechtGeorge_Kulchur3_1961_p19.jpg
// module id = No43
// module chunks = 0